import { Carrusel as c } from "../EditPanel/Carrusel";
import { conLanding } from "../Models/Landing";

export default class Carrusel extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}